import { render, staticRenderFns } from "./MigrateSubscription.vue?vue&type=template&id=aed0a92c&scoped=true&lang=pug&"
import script from "./MigrateSubscription.vue?vue&type=script&setup=true&lang=js&"
export * from "./MigrateSubscription.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MigrateSubscription.vue?vue&type=style&index=0&id=aed0a92c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed0a92c",
  null
  
)

export default component.exports